export const productDataUrl = "https://5d76bf96515d1a0014085cf9.mockapi.io/product";